import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { GroupAttribute } from './groupattribute.entity';
//#endregion

export const GroupAttributeConfig = {
  name: "GroupAttribute",
  annotations: [],
  fields: {
    groupId: {type: 'Edm.Int32'},
    attributeId: {type: 'Edm.Int32'},
    sortValue: {type: 'Edm.Int32'},
    attributeValue: {type: 'Edm.String'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    group: {type: 'entities.schema.Group', navigation: true, field: 'groupId', ref: 'id'},
    attribute: {type: 'entities.schema.Attribute', navigation: true, field: 'attributeId', ref: 'id'},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<GroupAttribute>;